<template>
  <div class="multiple-specs">
    <div class="title">
      <span class="col">规格名称</span>
      <span class="col2">规格值</span>
      <span class="col">操作</span>
    </div>
    <div class="row" v-for="(item, i) in rawSpecs" :key="i">
      <span class="col">
        <Input v-model="item.key" size="small" />
      </span>
      <span class="col2">
        <Tag
          v-for="(_item, i) in item.value"
          :key="_item"
          closable
          @on-close="handleCloseSpecsValue(item, i)"
          >{{ _item }}</Tag
        >
        <Poptip placement="top" width="200">
          <Button icon="ios-add" type="dashed" size="small">添加</Button>
          <Input
            slot="content"
            v-model="currentRowValueItem"
            @on-enter="handleAddSpecsValue(item)"
          >
            <Button slot="append" @click="handleAddSpecsValue(item)"
              >确定</Button
            >
          </Input>
        </Poptip>
      </span>

      <span class="col">
        <Button
          icon="md-trash"
          size="small"
          @click="removeItem(i)"
          long
          class="remove-btn"
        />
      </span>
    </div>
    <Button
      v-if="showAddButton"
      icon="md-add"
      @click="addItem"
      long
      class="add-btn"
    />
    <Button @click="createSKU" long class="add-btn" type="primary"
      >生成SKU</Button
    >
    <Table
      class="mt10"
      :data="skus"
      :columns="skuTableColumns"
      no-data-text="暂无SKU"
    ></Table>
    <Checkbox :value="needSize" @on-change="switchNeedSize">附加属性</Checkbox>
    <DynamicForm v-if="needSize" :model="extraSpecsForm" ref="extra">
    </DynamicForm>
  </div>
</template>
<style lang="stylus" scoped>
.multiple-specs
  .col
    flex: 1
    text-align: center

  .col2
    flex: 2.5
    padding: 0 10px

  .title
    display: flex
    justify-content: space-around

    .col2
      text-align: center

  .add-btn
    margin-top: 10px

  .row
    width: 100%
    display: flex
    margin-bottom: 10px

    .remove-btn
      width: 50px
      margin-left: 10px
</style>
<script>
export default {
  props: ['value', 'skus', 'extraSpecs', 'max'],
  data() {
    return {
      showAddButton: true,
      rawSpecs: [],
      currentRowValueItem: '',
      skuTableColumns: [],
      skuTableMustColumns: [
        {
          title: '缩略图',
          width: 80,
          render: (h, { row }) => {
            if (row.image) {
              return (
                <Poptip trigger="hover" transfer>
                  <img
                    style={{ width: '100%', height: '100%' }}
                    src={this.$envConst.IMAGE_ORIGIN + row.image}
                  />
                  <div slot="content">
                    <img src={this.$envConst.IMAGE_ORIGIN + row.image} />
                  </div>
                </Poptip>
              )
            } else {
              return <span>请上传</span>
            }
          },
        },
        {
          title: '销售价',
          minWidth: 100,
          render: (h, { index }) => {
            return h('Input', {
              props: {
                size: 'small',
                value: this.skus[index].price,
              },
              on: {
                'on-change': (event) => {
                  this.skus[index].price = event.target.value * 1
                },
              },
            })
          },
        },

        {
          title: '市场价',
          minWidth: 100,
          render: (h, { index }) => {
            return h('Input', {
              props: {
                size: 'small',
                value: this.skus[index].priceMarket,
              },
              on: {
                'on-change': (event) => {
                  this.skus[index].priceMarket = event.target.value * 1
                },
              },
            })
          },
        },
        {
          title: '成本价',
          minWidth: 100,
          render: (h, { index }) => {
            return h('Input', {
              props: {
                size: 'small',
                value: this.skus[index].priceCost,
              },
              on: {
                'on-change': (event) => {
                  this.skus[index].priceCost = event.target.value * 1
                },
              },
            })
          },
        },
        {
          title: '规格编码',
          width: 150,
          key: 'sku',
        },
        {
          title: '操作',
          width: 170,
          fixed: 'right',
          render: (h, { index }) => {
            return (
              <div >
                <Button
                  class="ml5"
                  size="small"
                  onclick={() => {
                    this.skus.splice(index, 1)
                  }}
                >
                  删除
                </Button>
                <Upload
                style="display:inline-block;"
                  action=""
                  before-upload={(file) => {
                    return this.skuUploadImage(index, file)
                  }}
                >
                  <Button class="ml5" size="small">
                    上传图片
                  </Button>
                </Upload>
              </div>
            )
          },
        },
      ],
      needSize: false,
      extraSpecsForm: {
        extraSpecs: {
          label: '附加属性',
          type: 'specs',
          specType: 0,
          max: 1,
          value: [],
          options: [
            {
              id: 6,
              code: 'size',
              name: '尺寸',
              vals: [
                {
                  id: 37,
                  attrId: 6,
                  value: '高',
                  symbol: 'height',
                  type: 'number',
                },
                {
                  id: 36,
                  attrId: 6,
                  value: '宽',
                  symbol: 'width',
                  type: 'number',
                },
                {
                  id: 35,
                  attrId: 6,
                  value: '长',
                  symbol: 'length',
                  type: 'number',
                },
              ],
            },
            {
              id: 7,
              code: 'weight',
              name: '重量',
              vals: [
                {
                  id: 40,
                  attrId: 7,
                  value: '公斤',
                  symbol: 'kg',
                  type: 'number',
                },
                {
                  id: 39,
                  attrId: 7,
                  value: '克',
                  symbol: 'g',
                  type: 'number',
                },
                {
                  id: 38,
                  attrId: 7,
                  value: '毫克',
                  symbol: 'mg',
                  type: 'number',
                },
              ],
            },
          ],
        },
      },
    }
  },
  inject: ['formData'],
  watch: {
    value: {
      handler(newValue) {
        // 此处value值等于产品详情对象的specs
        this.rawSpecs = []
        this.skuTableColumns = []
        newValue.forEach((item) => {
          // 通过specs生成SKU表格的动态列
          this.skuTableColumns.push({
            title: item.name,
            width: 115,
            key: item.code,
          })
          // 回显SKU配置表单
          this.rawSpecs.push({
            key: item.name,
            value: item.vals.map((val) => val.value),
          })
        })
        // 合并sku表格列
        this.skuTableColumns = [
          ...this.skuTableColumns,
          ...this.skuTableMustColumns,
        ]
      },
      immediate: true,
    },
    extraSpecs: {
      handler(newValue) {
        // console.log('extraSpecs改变', newValue)
        if (newValue && newValue.length > 0) {
          this.needSize = true
          this.extraSpecsForm.extraSpecs.value = newValue.map((item) => {
            item.valsOptions = [
              {
                value: '高',
                symbol: 'height',
              },
              {
                value: '宽',
                symbol: 'width',
              },
              {
                value: '长',
                symbol: 'length',
              },
            ]
            item.valsSelect = item.vals.map((val) => val.value)
            return item
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    addItem() {
      // if (this.options.length === 0)
      //   return this.$Message.warning('请先选择产品分类')
      let newValueItem = {
        key: '',
        value: [],
      }
      this.rawSpecs.push(newValueItem)
    },
    removeItem(i) {
      if (this.rawSpecs.length === 1)
        return this.$Message.warning('至少需要1条数据')
      this.$delete(this.rawSpecs, i)
    },
    handleAddSpecsValue(row) {
      row.value.push(this.currentRowValueItem)
      this.currentRowValueItem = ''
    },
    handleCloseSpecsValue(row, i) {
      row.value.splice(i, 1)
    },
    createSKU() {
      if (this.rawSpecs.length === 0)
        return this.$Message.warning('请先添加规格')
      this.$Modal.confirm({
        title: '注意',
        content: '生成规格将清空现有规格数据、是否继续？',
        okText: '继续',
        onOk: () => {
          let specs = {}
          this.rawSpecs.forEach((item) => {
            const objectToArray = Object.entries(item)
            specs[objectToArray[0][1]] = objectToArray[1][1]
          })
          this.$axios
            .post('/mall/product/sku/gen', {
              specs,
              skus: this.skus,
            })
            .then((data) => {
              this.$emit('change', {
                prop: 'value',
                value: data.specs,
              })
              this.$emit('change', {
                prop: 'skus',
                value: data.skus.map((item) => {
                  item.price = item.price || this.formData.price
                  item.priceCost = item.priceCost || this.formData.priceCost
                  item.priceMarket =
                    item.priceMarket || this.formData.priceMarket

                  item.specName.forEach((name, i) => {
                    item[name] = item.specVal[i]
                  })
                  return item
                }),
              })
            })
        },
      })
    },
    skuUploadImage(index, file) {
      const formDate = new FormData()
      formDate.append(
        'folder',
        `/goods/spces/images/${this.$dayjs().format('YYYYMMDD')}`
      )
      formDate.append('file', file)
      this.$axios.post('/funs/upload/image', formDate).then((data) => {
        this.$set(this.skus, index, { ...this.skus[index], image: data })
      })
      return false
    },
    switchNeedSize(value) {
      this.needSize = value
      if (value) {
        this.$nextTick(() => {
          this.$emit('change', {
            prop: 'extraSpecs',
            value: [
              {
                code: 'size',
                input: true,
                name: '尺寸',
                type: 2,
                vals:
                  [
                    { value: '长', symbol: 'length' },
                    { value: '宽', symbol: 'width' },
                    { value: '高', symbol: 'height' },
                  ],
                valsOptions: [
                  {
                    value: '高',
                    symbol: 'height',
                  },
                  {
                    value: '宽',
                    symbol: 'width',
                  },
                  {
                    value: '长',
                    symbol: 'length',
                  },
                ],
                valsSelect: ['高', '宽', '长'],
              },
            ],
          })
        })
      } else {
        this.$emit('change', {
          prop: 'extraSpecs',
          value: [],
        })
        localStorage.setItem('extraSpecs',[])
      }
    },
  },
}
</script>
